import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { getPlaceholderUrl } from "../../../../utils";

interface TemplateArgs {
    zoomInLabel?: string;
    zoomOutLabel?: string;
}

export const Template = ({ zoomInLabel, zoomOutLabel }: TemplateArgs) => html`
    <ux-iws-nb-image-zoom
        zoom-in-label=${ifDefined(zoomInLabel)}
        zoom-out-label=${ifDefined(zoomOutLabel)}
    >
        <div slot="image">
            <picture>
                <source
                    media="(max-width: 1023px)"
                    data-srcset="./mock-assets/nimbus/product-header-3-2.jpg"
                />
                <source
                    media="(min-width: 1024px)"
                    data-srcset="./mock-assets/nimbus/product-header-3-1.jpg"
                />
                <img
                    class="lazyload"
                    alt="Product image with 3:2 aspect ratio for mobile and 3:1 for desktop"
                    src=${getPlaceholderUrl(1920, 640)}
                />
            </picture>
        </div>
        <div slot="zoom-image">
            <picture>
                <img
                    data-src="./mock-assets/nimbus/product-header-3-2@2x.jpg"
                    alt="Hires product image with 3:2 aspect ratio (zoomed)"
                />
            </picture>
        </div>
    </ux-iws-nb-image-zoom>
`;

export const templateArgs: TemplateArgs = {
    zoomInLabel: "Zoom In",
    zoomOutLabel: "Zoom Out",
};
